import React from 'react';

import ArrowRight from 'components/Icons/ArrowRight';
import Home from 'components/Icons/Home';
import colors from 'utils/colors';

import BackButton from './BackButton';
import ButtonContainer from './ButtonContainer';
import { BreadCrumbOption } from './interfaces';
import * as Styled from './styled';

export type ComponentProps = {
  /**
   * Items to render
   */
  items: BreadCrumbOption[];

  /**
   * Indicates whether to create a border-bottom or not
   *
   * @default false
   */
  noBorder?: boolean;

  /**
   * The page where the home breadcrumb links to
   *
   * @default 'https://www.service.vic.gov.au'
   */
  homeLink?: string;
};

export const BreadCrumb: React.FC<ComponentProps> = ({
  items,
  noBorder,
  homeLink = 'https://www.service.vic.gov.au'
}) =>
  items.length > 0 ? (
    <Styled.Background>
      <Styled.Wrapper noBorder={noBorder}>
        <BackButton items={items} />
        <Styled.Container>
          <Styled.HomeButtonWrapper href={homeLink} title='Homepage'>
            <Styled.HomeButtonIconHolder mode='main'>
              <Home fill={colors.orange} />
            </Styled.HomeButtonIconHolder>
            <Styled.HomeButtonIconHolder mode='secondary'>
              <ArrowRight fill={colors.orange} />
            </Styled.HomeButtonIconHolder>
          </Styled.HomeButtonWrapper>
        </Styled.Container>
        <ButtonContainer items={items} />
      </Styled.Wrapper>
    </Styled.Background>
  ) : null;

export default BreadCrumb;
